import "leaflet/dist/leaflet.css";
import { map, tileLayer, marker as Lmarker, icon, latLngBounds } from "leaflet";

class ProgrammeMap {
	constructor() {
		this.container = document.getElementById("programme-map");
		if (!this.container) return;

		this.mapOptions = {
			attributionControl: false,
		};
		this.markersData = JSON.parse(this.container.dataset.map);

		this.map = null;
		this.initMap();

		this.addTile();

		this.icon = null;
		this.hoverIcon = null;
		this.setIcons();

		this.markers = [];
		this.currentMarker = null;
		this.addMarkers();
		this.fitBounds();
	}

	initMap() {
		this.map = map(this.container, this.mapOptions);
	}

	/**
	 * @see https://leaflet-extras.github.io/leaflet-providers/preview/index.html
	 */
	addTile() {
		tileLayer(
			"https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
			{
				attribution:
					'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
				subdomains: "abcd",
				maxZoom: 13,
			}
		).addTo(this.map);
	}

	setIcons() {
		this.icon = this.getIcon();
		this.hoverIcon = this.getIcon(true);
	}

	getIcon(isHover = false) {
		if (isHover && this.hoverIcon) return this.hoverIcon;
		if (!isHover && this.icon) return this.icon;

		return icon({
			iconUrl: `/wp-content/themes/greenstone/src/images/map-icon.svg`,
			iconSize: [32, 32],
			iconAnchor: [16, 16],
		});
	}

	addMarkers() {
		this.markersData.forEach((m) => {
			const { lat, lng, title } = m;
			const marker = Lmarker([lat, lng], {
				alt: title,
				keyboard: false,
				icon: this.getIcon(),
			});
			marker.addTo(this.map);
            marker.bindPopup(this.getInfoPopup(m));
			this.markers = [...this.markers, marker];
		});
	}

	getBounds() {
		const bounds = latLngBounds([]);
		this.markers.forEach((m) => {
			bounds.extend(m.getLatLng());
		});

		return bounds;
	}

	fitBounds() {
		const bounds = this.getBounds();
		this.map.fitBounds(bounds, { padding: [50, 50] });

		if (this.map.getZoom() >= 10) this.map.setZoom(10);
	}

	getInfoPopup({title, zip, city, url}) {
		return `
            <div class="marker">
                <div class="marker__content">
                    <h2 class="marker__title">${title}</h2>
                    <p class="marker__address">${zip} ${city}</p>
                    <a href="${url}" class="marker__link link">
                        <span>DÉCOUVRIR</span>
                        <svg class="icon">
                            <use xlink:href="#icon-arrow-right"></use>
                        </svg>
                    </a>
                </div>
            </div>
        `;
	}
}

document.addEventListener("DOMContentLoaded", () => {
	new ProgrammeMap();
});
